import {
  Glass,
  Dot,
  DisplayText,
  BodyText,
  BackNav,
  Chevron,
} from "../../components/mobile/primitives";

/** All Files screen with active search — navigated from Profile tab search bar */
export function FlowVaultSearch() {
  const results = [
    {
      dot: "var(--color-kin-green-soft)",
      title: "Blood Panel Feb 2026",
      sub: "Lab report · Feb 12",
    },
    {
      dot: "var(--color-kin-green-soft)",
      title: "Blood Panel Aug 2025",
      sub: "Lab report · Aug 3",
    },
  ];

  return (
    <div style={{ padding: "8px 16px 0", display: "flex", flexDirection: "column", gap: 12 }}>
      {/* Back nav + header */}
      <div style={{ display: "flex", flexDirection: "column", gap: 4, paddingLeft: 4 }}>
        <BackNav label="Profile" />
        <DisplayText size={24}>All Files</DisplayText>
      </div>

      {/* Active search — highlighted border like onboarding's selected card */}
      <Glass
        style={{ borderRadius: 14, padding: "10px 14px", borderColor: "rgba(91,122,102,0.25)" }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--color-kin-green-soft)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="M21 21l-4.35-4.35" />
          </svg>
          <BodyText size={10} color="var(--color-kin-black)" weight={500}>
            blood
          </BodyText>
          <div
            style={{
              marginLeft: "auto",
              width: 16,
              height: 16,
              borderRadius: 8,
              background: "rgba(0,0,0,0.06)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <BodyText size={8} color="var(--color-kin-muted)" weight={600}>
              ×
            </BodyText>
          </div>
        </div>
      </Glass>

      {/* Results count */}
      <BodyText size={9} color="var(--color-kin-muted)" weight={500} style={{ paddingLeft: 4 }}>
        2 results
      </BodyText>

      {/* Filtered file list */}
      <Glass style={{ borderRadius: 20 }}>
        <div style={{ padding: "0 14px" }}>
          {results.map((f, i) => (
            <div
              key={f.title}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                padding: "12px 0",
                borderBottom: i < results.length - 1 ? "1px solid rgba(0,0,0,0.05)" : "none",
              }}
            >
              <Dot color={f.dot} size={7} />
              <div style={{ flex: 1 }}>
                <BodyText size={10} weight={700}>
                  <span
                    style={{
                      background: "rgba(255,208,40,0.20)",
                      borderRadius: 2,
                      padding: "0 1px",
                    }}
                  >
                    Blood
                  </span>{" "}
                  Panel {f.title.includes("Feb") ? "Feb 2026" : "Aug 2025"}
                </BodyText>
                <BodyText size={8.5} color="var(--color-kin-muted)" weight={400}>
                  {f.sub}
                </BodyText>
              </div>
              <Chevron />
            </div>
          ))}
        </div>
      </Glass>

      {/* Empty state hint */}
      <div style={{ textAlign: "center", padding: "16px 0" }}>
        <BodyText size={9} color="var(--color-kin-muted)" weight={400}>
          Try searching by file name, category, or date
        </BodyText>
      </div>
    </div>
  );
}
